let id = 0;

export function generateId(): number {
  id += 1;

  return id;
}

export function generateUniq(): string {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
}
